import * as R from "ramda"

export function get_elements_by_level(level, fieldModels) {
    return R.filter(

        fieldModel => get_level(fieldModel.id) === level

    )(fieldModels)
}

export function get_level(id) {
    return R.compose(

        // Anzahl der Element zurueckgegen
        // > [ "1", "1" ]
        // < 2
        R.prop("length"),

        // In Array splitten
        // > "1-1"
        // < [ "1", "1" ]
        R.split("-"),

        // Es duerfte nur noch eine Element aus Zahlen und Minuszeichen vorhanden sein. Das jetzt "unboxen"
        // > [ "1-1" ]
        // < "1-1"
        R.nth(0),

        // Alle Elemente ausfiltern, die nicht nur aus Zahlen und Minuszeichen bestehen
        // > [ "flyer-faltblaetter/", "1-1" ]
        // < [ "1-1" ]
        R.reject(element => element.match(/[^\d-]/g) !== null),


        // > "flyer-faltblaetter/1-1"
        // < [ "flyer-faltblaetter/", "1-1" ]
        R.split("/"),

    )(id)
}

export function root_level(id) {
    return R.compose(

        // Ersten split holen
        // > [ "2", "1", "1" ]
        // < "2"
        R.head,

        // Bei `-` splitten
        // > "2-1-1"
        // < [ "2", "1", "1" ]
        R.split("-"),

        // Letzten Split holen
        // > [ "buecher", "hardcover-buch", "2-1-1" ]
        // < "2-1-1"
        R.last,

        // Bei `/` splitten
        // > "buecher/hardcover-buch/2-1-1"
        // < [ "buecher", "hardcover-buch", "2-1-1" ]
        R.split("/"),

    )(id)
}

export function sort_field_models_on_level(level, fieldModels) {
    const sort = R.compose(

        // "ID" links mit "0" auffuellen
        // > "2"
        // > "000000000002"
        id => id.padStart(12, '0'),

        // ggf. Leer-String als Standardwert setzen
        // > "2"
        // < ""
        R.defaultTo(''),

        // "ID" bei Level holen
        // > [ "2", "1", "1" ]
        // < "2"
        R.nth(level - 1),

        // Bei `-` splitten
        // > "2-1-1"
        // < [ "2", "1", "1" ]
        R.split("-"),

        // Letzten Split holen
        // > [ "buecher", "hardcover-buch", "2-1-1" ]
        // < "2-1-1"
        R.last,

        // Bei `/` splitten
        // > "buecher/hardcover-buch/2-1-1"
        // < [ "buecher", "hardcover-buch", "2-1-1" ]
        R.split("/"),

        // ID auslesen
        // > { id: "buecher/hardcover-buch/2-1-1", ... }
        // < "buecher/hardcover-buch/2-1-1"
        R.prop('id')
    )

    return R.sortBy(sort, fieldModels)
}

export function type_id_to_form_id(typeId) {
    const relations = {
        1:  'plakate',
        2:  'flyer-faltblaetter',
        3:  'fotosatz-lose-blattsammlung',
        4:  'broschuren-pressehefte-kataloge',
        5:  'gutscheine-karten',
        6:  'cd-dvd',
        7:  'beileger-booklets',
        8:  'banner',
        10: 'aufsteller-displays/standee',
        11: 'aufsteller-displays/deckenhaenger',
        12: 'aufsteller-displays/saeule',
        13: 'aufkleber-etiketten/aufkleber',
        14: 'aufsteller-displays/roll-up-display',
        16: 'geschaeftsausstattung/bloecke',
        17: 'geschaeftsausstattung/briefboegen',
        18: 'geschaeftsausstattung/briefhuellen-umschlaege',
        19: 'geschaeftsausstattung/visitenkarten',
        20: 'geschaeftsausstattung/praesentationsmappen',
        22: 'aufkleber-etiketten/etiketten-auf-rolle',
        23: 'aufkleber-etiketten/etiketten-auf-bogen',
        24: 'aufkleber-etiketten/aufkleber-auf-bogen',
        25: 'aufkleber-etiketten/verkaufsdisplay',
        26: 'aufkleber-etiketten/grossaufkleber',
        28: 'kalender/terminkalender-fester-einband',
        29: 'kalender/terminkalender-weicher-einband',
        30: 'kalender/tischkalender',
        32: 'buecher/hardcover-buch',
        33: 'buecher/softcover-buch',
        34: 'textilien',
        35: 'konfektionierung'
    }

    return relations[typeId]
}

